// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profil-container {
  padding: 2rem 3.5rem;
  background: #FAFAFA;
  min-height: 100vh;
}

.profil-container h1 {
  margin-bottom: 2rem;
}

.profil-tabs {
  margin-bottom: 2rem;
}

.profil-tab-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 1.5rem;
}

.profil-header {
  display: flex;
  align-items: center;
  gap: 2rem;
  margin-bottom: 2rem;
}

/* .profil-container .logo-placeholder {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  background: rgba(215, 217, 217, 0.20);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  font-weight: 700;
} */

.profil-container .profil-header h2 {
  font-size: 2.1rem;
  font-weight: 700;
}

/* .profil-container .section-title {
  font-size: 1.35rem;
  font-weight: 700;
  margin-bottom: 0.7rem;
  border-bottom: 2px solid #222;
  padding-bottom: 0.3rem;
  margin-top: 3rem;
  padding-top: 1.5rem;
  border-top: 1px solid #E5E7EB;
} */

.profil-container .form-group {
  margin-bottom: 0.5rem;
}

.profil-container .button-container {
  margin-top: 1.2rem;
}


.gestion-comptes-compact {
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.profil-documents-page {
  padding: 0;
  background: none;
  box-shadow: none;
  border-radius: 0;
  margin-bottom: 0;
}

.mes-documents {
  padding: 0;
  max-width: 100%;
  margin: 0;
}

/* .document-section {
  background: #FFFDFC;
  padding: 2rem;
  border-radius: 0.8rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 8px rgba(44,57,72,0.04);
} */

.document-name {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 1.4rem;
}

.add-document-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 2rem;
}

.profil-tab-page .button-container {
  display: flex;
  justify-content: flex-end;
}

/* Style pour le tooltip des onglets inactifs */
.profil-tabs .tab-button.inactive {
  position: relative;
}

.profil-tabs .tab-button.inactive:hover::before {
  content: attr(data-tooltip);
  position: absolute;
  bottom: calc(100% + 10px); /* Position au-dessus de l'onglet avec un peu d'espace */
  left: 50%;
  transform: translateX(-50%);
  padding: 8px 12px;
  background-color: #333;
  color: #fff;
  border-radius: 4px;
  font-size: 14px;
  white-space: nowrap;
  visibility: visible;
  opacity: 1;
  z-index: 100;
}

/* Flèche du tooltip */
.profil-tabs .tab-button.inactive:hover::after {
  content: '';
  position: absolute;
  bottom: calc(100% + 5px);
  left: 50%;
  transform: translateX(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: #333 transparent transparent transparent;
  visibility: visible;
  opacity: 1;
}

/* Style pour le message "Fonctionnalité à venir" */
.coming-soon-message {
  text-align: center;
  padding: 3rem;
  background-color: rgba(215, 217, 217, 0.20);
  border-radius: 8px;
  margin: 2rem 0;
  border-left: 4px solid #DA7027;
}

.coming-soon-message h2 {
  color: #2c3948;
  margin-bottom: 1rem;
}

.coming-soon-message p {
  color: #6b7280;
  font-size: 1.6rem;
}

.identifiant-connexion {
  margin-bottom: 2rem !important;
}

.identifiant-connexion-input {
  display: flex;
}

.identifiant-connexion-input > button {
  width: 419px;
  margin-left: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/Profil/Profil.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;;;;;;;;GAUG;;AAEH;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;;;;;;GASG;;AAEH;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,SAAS;AACX;;AAEA;;;;;;GAMG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,yBAAyB,EAAE,wDAAwD;EACnF,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;EACtD,mBAAmB;EACnB,UAAU;AACZ;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":[".profil-container {\r\n  padding: 2rem 3.5rem;\r\n  background: #FAFAFA;\r\n  min-height: 100vh;\r\n}\r\n\r\n.profil-container h1 {\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.profil-tabs {\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.profil-tab-header {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.profil-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 2rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n/* .profil-container .logo-placeholder {\r\n  width: 110px;\r\n  height: 110px;\r\n  border-radius: 50%;\r\n  background: rgba(215, 217, 217, 0.20);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 1.25rem;\r\n  font-weight: 700;\r\n} */\r\n\r\n.profil-container .profil-header h2 {\r\n  font-size: 2.1rem;\r\n  font-weight: 700;\r\n}\r\n\r\n/* .profil-container .section-title {\r\n  font-size: 1.35rem;\r\n  font-weight: 700;\r\n  margin-bottom: 0.7rem;\r\n  border-bottom: 2px solid #222;\r\n  padding-bottom: 0.3rem;\r\n  margin-top: 3rem;\r\n  padding-top: 1.5rem;\r\n  border-top: 1px solid #E5E7EB;\r\n} */\r\n\r\n.profil-container .form-group {\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.profil-container .button-container {\r\n  margin-top: 1.2rem;\r\n}\r\n\r\n\r\n.gestion-comptes-compact {\r\n  padding-left: 0.5rem !important;\r\n  padding-right: 0.5rem !important;\r\n  padding-top: 1rem !important;\r\n  padding-bottom: 1rem !important;\r\n}\r\n\r\n.profil-documents-page {\r\n  padding: 0;\r\n  background: none;\r\n  box-shadow: none;\r\n  border-radius: 0;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.mes-documents {\r\n  padding: 0;\r\n  max-width: 100%;\r\n  margin: 0;\r\n}\r\n\r\n/* .document-section {\r\n  background: #FFFDFC;\r\n  padding: 2rem;\r\n  border-radius: 0.8rem;\r\n  margin-bottom: 2rem;\r\n  box-shadow: 0 2px 8px rgba(44,57,72,0.04);\r\n} */\r\n\r\n.document-name {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  font-size: 1.4rem;\r\n}\r\n\r\n.add-document-container {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.profil-tab-page .button-container {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n/* Style pour le tooltip des onglets inactifs */\r\n.profil-tabs .tab-button.inactive {\r\n  position: relative;\r\n}\r\n\r\n.profil-tabs .tab-button.inactive:hover::before {\r\n  content: attr(data-tooltip);\r\n  position: absolute;\r\n  bottom: calc(100% + 10px); /* Position au-dessus de l'onglet avec un peu d'espace */\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  padding: 8px 12px;\r\n  background-color: #333;\r\n  color: #fff;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  white-space: nowrap;\r\n  visibility: visible;\r\n  opacity: 1;\r\n  z-index: 100;\r\n}\r\n\r\n/* Flèche du tooltip */\r\n.profil-tabs .tab-button.inactive:hover::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: calc(100% + 5px);\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  border-width: 5px;\r\n  border-style: solid;\r\n  border-color: #333 transparent transparent transparent;\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n\r\n/* Style pour le message \"Fonctionnalité à venir\" */\r\n.coming-soon-message {\r\n  text-align: center;\r\n  padding: 3rem;\r\n  background-color: rgba(215, 217, 217, 0.20);\r\n  border-radius: 8px;\r\n  margin: 2rem 0;\r\n  border-left: 4px solid #DA7027;\r\n}\r\n\r\n.coming-soon-message h2 {\r\n  color: #2c3948;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.coming-soon-message p {\r\n  color: #6b7280;\r\n  font-size: 1.6rem;\r\n}\r\n\r\n.identifiant-connexion {\r\n  margin-bottom: 2rem !important;\r\n}\r\n\r\n.identifiant-connexion-input {\r\n  display: flex;\r\n}\r\n\r\n.identifiant-connexion-input > button {\r\n  width: 419px;\r\n  margin-left: 1rem;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
